import { NavigateHeader } from '@/components/atoms/navigate-header'
import { Layout } from '@/components/template/layout'
import { pcScreenStyle } from '@/styles/common'
import React from 'react'

type Props = {
  title: string
  tabs?: React.ReactNode
  children: React.ReactNode
}

export const IdentityVerifyTemplate: React.FC<Props> = ({ title, tabs, children }) => (
  <Layout>
    <NavigateHeader title={title} style={{ marginBottom: '24px' }} />
    <div css={pcScreenStyle}>
      {tabs}
      {children}
    </div>
  </Layout>
)
